export enum ModalTypes {
  instructorCoachPromo = 'instructor-coach-promo',
  subscriptions = 'subscriptions',
  payment = 'payment',
  languageSuggest = 'language_suggest',
  studentCertInfo = 'student-cert-info',
  renewMembership = 'renew-membership',
  help = 'help',
  confirm = 'confirm',
  bankTransferInfo = 'bank-transfer-info',
  standard = 'standard',
  mapSelector = 'map-selector',
  segmentationForm = 'segmentation-form',
  insertMandatoryFields = 'insert-mandatory-fields',
  fullSizeGallery = 'full-size-gallery',
  LoginRegister = 'login-register',
  diploma = 'diploma',
  orderSummary = 'order-summary',
  certRequirements = 'cert-requirements',
}
